import {Tabs} from '@mantine/core';
import classes from './tabs.module.css';

export const TabsTheme = Tabs.extend({
  classNames: {
    tab: classes.tab,
  },
});